import { useState } from "react";
import { Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { DropdownSelect } from "components/DropdownSelect";
import { CustomInputModal } from "components/CustomInputModal";
import { CustomDatePicker } from "components/DatePicker";
import { MaisFiltros } from "components/ButtonModal";
import { useEmpresas } from "hooks/useEmpresas";
import { useUsuariosTaxa } from "../../hooks/useUsuariosTaxa";
import {
  AcoesContainer,
  Button,
  ButtonsContainer,
  Container,
  DatePickerContainer,
  FormContainer,
  InputContainer,
  InputContainerMaisFiltros,
  Title,
} from "./style";
import { IFiltroPagamentoTaxa } from "../../interfaces/IFiltroPagamentoTaxa";
import { statusOptions } from "../../constants/optionsFiltros";

interface IProps {
  submitForm: (dados: IFiltroPagamentoTaxa) => void;
  validarProcessos: (processos: string[]) => Promise<any>;
  validarVeiculos: (placasChassisRenavams: string[]) => Promise<any>;
}

export function FiltroPagamentoTaxa({
  submitForm,
  validarProcessos,
  validarVeiculos,
}: IProps) {
  const { handleSubmit, control, setValue } = useForm<IFiltroPagamentoTaxa>({
    defaultValues: {
      idsProcessos: [],
      dadosVeiculos: [],
      idUsuario: null,
      status: null,
      idsLotes: [],
      idEmpresa: null,
      dataCadastro: null,
    },
  });

  const [inicioCadastro, setInicioCadastro] = useState<Date | undefined>();
  const [fimCadastro, setFimCadastro] = useState<Date | undefined>();

  const { empresasOptions } = useEmpresas();
  const { usuariosOptions } = useUsuariosTaxa();

  const aplicar = (dados: IFiltroPagamentoTaxa) => {
    submitForm({
      ...dados,
      dataCadastro:
        inicioCadastro && fimCadastro ? [inicioCadastro, fimCadastro] : null,
    });
  };

  const handleLimpar = () => {
    setValue("idsProcessos", []);
    setValue("dadosVeiculos", []);
    setValue("idUsuario", null);
    setValue("status", null);
    setValue("idsLotes", []);
    setValue("idEmpresa", null);
    setValue("dataCadastro", null);
    setInicioCadastro(undefined);
    setFimCadastro(undefined);
    submitForm({});
  };

  const handleLimparMaisFiltros = () => {
    setValue("idsLotes", []);
    setValue("idEmpresa", null);
    setValue("dataCadastro", null);
    setInicioCadastro(undefined);
    setFimCadastro(undefined);
  };

  return (
    <Container>
      <Title>Filtros</Title>
      <hr />
      <FormContainer>
        <Form noValidate onSubmit={handleSubmit(aplicar)}>
          <Row>
            <InputContainer lg="2">
              <Form.Group>
                <Form.Label>ID Processo</Form.Label>
                <Controller
                  control={control}
                  name="idsProcessos"
                  defaultValue={[]}
                  render={({ field: { onChange, value } }) => (
                    <CustomInputModal
                      label="Filtrar em massa"
                      value={value ?? []}
                      placeholder="Busque pelo ID"
                      onConfirm={onChange}
                      onClickOk={validarProcessos}
                      validar={true}
                      style={{ width: "100%" }}
                      placeholderModal="Digite ou cole os IDs dos processos e tecle ENTER"
                      labelItem="Processos"
                    />
                  )}
                />
              </Form.Group>
            </InputContainer>

            <InputContainer lg="2">
              <Form.Group>
                <Form.Label>Veículo</Form.Label>
                <Controller
                  control={control}
                  name="dadosVeiculos"
                  defaultValue={[]}
                  render={({ field: { onChange, value } }) => (
                    <CustomInputModal
                      label="Filtrar em massa"
                      value={value ?? []}
                      placeholder="Placa, chassi ou renavam"
                      onConfirm={onChange}
                      onClickOk={validarVeiculos}
                      validar={true}
                      style={{ width: "100%" }}
                      placeholderModal="Digite ou cole placa, chassi ou renavam e tecle ENTER"
                      labelItem="Veículos"
                    />
                  )}
                />
              </Form.Group>
            </InputContainer>

            <InputContainer lg="2">
              <Form.Group>
                <Form.Label>Usuário responsável</Form.Label>
                <Controller
                  control={control}
                  name="idUsuario"
                  render={({ field: { onChange, value } }) => (
                    <DropdownSelect
                      title=""
                      options={usuariosOptions}
                      selectedValue={value ?? undefined}
                      onSelect={onChange}
                      searchable
                    />
                  )}
                />
              </Form.Group>
            </InputContainer>

            <InputContainer lg="2">
              <Form.Group>
                <Form.Label>Status</Form.Label>
                <Controller
                  control={control}
                  name="status"
                  render={({ field: { onChange, value } }) => (
                    <DropdownSelect
                      title=""
                      options={statusOptions}
                      selectedValue={value ?? undefined}
                      onSelect={onChange}
                    />
                  )}
                />
              </Form.Group>
            </InputContainer>

            <InputContainer lg="4">
              <Form.Group>
                <ButtonsContainer>
                  <AcoesContainer>
                    <Button
                      type="reset"
                      outline
                      variante="primary"
                      style={{ width: "76px" }}
                      onClick={handleLimpar}
                    >
                      Limpar
                    </Button>
                    <Button type="submit" style={{ width: "76px" }}>
                      Buscar
                    </Button>
                  </AcoesContainer>
                  <MaisFiltros
                    handleClickAplicarFiltros={handleSubmit(aplicar)}
                    limparTudoOnClick={handleLimparMaisFiltros}
                    cancelarOnClick={handleLimparMaisFiltros}
                  >
                    <InputContainerMaisFiltros>
                      <Form.Label>ID Lote</Form.Label>
                      <Controller
                        control={control}
                        name="idsLotes"
                        defaultValue={[]}
                        render={({ field: { onChange, value } }) => (
                          <CustomInputModal
                            label="Filtrar em massa"
                            value={value ?? []}
                            placeholder="Busque pelo lote"
                            onConfirm={onChange}
                            validar={false}
                            style={{ width: "100%" }}
                            placeholderModal="Digite ou cole os IDs dos lotes e tecle ENTER"
                            labelItem="Lotes"
                          />
                        )}
                      />
                    </InputContainerMaisFiltros>

                    <InputContainerMaisFiltros>
                      <Form.Label>Período de cadastro</Form.Label>
                      <DatePickerContainer>
                        <CustomDatePicker
                          selected={inicioCadastro}
                          onChange={(dates: any) => {
                            const [start, end] = dates;
                            setInicioCadastro(start);
                            setFimCadastro(end);
                          }}
                          startDate={inicioCadastro}
                          endDate={fimCadastro}
                          rangeSelect={true}
                        />
                      </DatePickerContainer>
                    </InputContainerMaisFiltros>

                    <InputContainerMaisFiltros>
                      <Form.Label>Empresa</Form.Label>
                      <Controller
                        control={control}
                        name="idEmpresa"
                        render={({ field: { onChange, value } }) => (
                          <DropdownSelect
                            title=""
                            options={empresasOptions}
                            selectedValue={value ?? undefined}
                            onSelect={onChange}
                            searchable
                          />
                        )}
                      />
                    </InputContainerMaisFiltros>
                  </MaisFiltros>
                </ButtonsContainer>
              </Form.Group>
            </InputContainer>
          </Row>
        </Form>
      </FormContainer>
    </Container>
  );
}
